import { FormControl, FormGroup } from '@angular/forms';

export interface CustomCodeFormShape {
  enabled: FormControl<boolean>;
  code: FormControl<string>;
}

export interface CustomCodeVariableDoc {
  reference: string;
  type: string;
  description: string;
}

export function createCustomCodeFormGroup(
  initialSettings?: Record<string, unknown> | null,
  defaultCode = '',
): FormGroup<CustomCodeFormShape> {
  const formGroup = new FormGroup<CustomCodeFormShape>({
    enabled: new FormControl(false, { nonNullable: true }),
    code: new FormControl(defaultCode, { nonNullable: true }),
  });

  if (initialSettings) {
    formGroup.patchValue(initialSettings, { emitEvent: false });
  }

  return formGroup;
}
